<template>
    <div id="item" v-cloak>
      <div id="itemHolder">
        <div id="ileft">
          <div id="picHolder">
            <transition name="fade">
              <img :src="'/images/namjestaj/' + itemObject.artikli_id + '/' + pixIndex + '.jpg'" :alt="itemObject.podkat_naziv + ' ' + itemObject.artikli_naziv" :key="pixIndex"/>
            </transition>
          </div>
          <div id="restPic">
            <div class="restEl" v-for="index in (Number(itemObject.artikli_brojslika) || 0)" :key="'a' + index">
              <img :src="'/images/namjestaj/' + itemObject.artikli_id + '/' + (index - 1) + '.jpg'"  @click="changeImage(index-1)" />
            </div>
          </div>
        </div>
        <div id="iright">
          <div id="katt"><h3>{{itemObject.kategorija_naziv}}</h3></div>
          <div id="title"><h1>{{itemObject.podkat_naziv}} {{itemObject.artikli_naziv}}</h1></div>
          <div id="boja" v-if="itemObject.artikli_boje">Boja: {{itemObject.artikli_boje}}</div><br>
          <div id="dobavljac" v-if="itemObject.dobavljac_link && itemObject.dobavljac_dal">Dobavljač: {{itemObject.dobavljac_naziv}}<br><a :href="'http://' + itemObject.dobavljac_link" target="_blank">{{itemObject.dobavljac_link}}</a></div>
          <div id="dobavljac" v-else-if="itemObject.dobavljac_dal">Dobavljač: {{itemObject.dobavljac_naziv}}</div>
          <div id="tekst" v-html="itemObject.artikli_opis"></div>
          <div id="cijena" class="nds" v-if="dalce === '0'">TRENUTNO<br>NEDOSTUPNO</div>
          <div id="cijena" v-else class="klk" v-on:click.prevent="dodaj()">{{donjaC}}€<div id="akcija" v-if="itemObject.artikli_akcija==1">AKCIJA!</div><div id="dodaj">dodaj</div></div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Item',
  data () {
    return {
      itemObject: {},
      pixIndex: 0,
      razlika: 4
    }
  },
  metaInfo () {
    return {
      title: this.sTitle,
      meta: [
        { name: 'description', content: this.sDesc },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'vndnamjestaj' },
        { property: 'og:title', content: this.sTitle },
        { property: 'og:image', content: this.sImage },
        { property: 'og:url', content: 'https://vndnamjestaj.me' + this.$route.path }
      ]
    }
  },
  props: {
    id: String
  },
  mounted () {
    this.loadItem()
  },
  methods: {
    async loadItem () {
      this.itemObject = {}
      const response = await fetch('https://vndnamjestaj.me/kaoitemlist.php?id=' + this.id)
      const data = await response.json()
      this.itemObject = data[0]
    },
    changeImage (idx) {
      this.pixIndex = idx
    },
    dodaj () {
      this.$store.dispatch('dodMoj', this.itemObject)
    }
  },
  watch: {
    $route (to, from) {
      this.loadItem()
    }
  },

  computed: {
    klIDs () {
      return this.$store.getters.sId
    },
    donjaC () {
      if (this.itemObject.artikli_donjacijena) {
        return this.itemObject.artikli_donjacijena.toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')
      }
      return 0
    },
    sTitle () {
      if (this.itemObject.podkat_naziv) {
        return this.itemObject.podkat_naziv + ' ' + this.itemObject.artikli_naziv + ' - VND namještaj'
      }
      return null
    },
    sDesc () {
      if (this.itemObject.artikli_opis) {
        return this.itemObject.artikli_opis
      }
      return null
    },
    sIamge () {
      return '/images/namjestaj/' + this.itemObject.artikli_id + '/0.jpg'
    },
    dalce () {
      return this.itemObject.artikli_donjacijena ? this.itemObject.artikli_donjacijena.toString() : null
    }
  }
}
</script>
<style lang="scss" scoped>

#item{
  position: relative;
  overflow: visible;
}

h3{
  font-weight: 300;
  text-transform: uppercase;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  position: absolute;
}

.fade-enter-active, .fade-leave-active{
  transition: all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

#akcija{
  position: absolute;
  transform: translateY(-2.4vw);
  color:RGBA(255,0,0,1)
}

#ileft{
  position: absolute;
  width: 60%;
  height: auto;
  top: 13px;
}

@media only screen and (max-width: 600px) {
  #akcija{
  position: absolute;
  top: -10px;
  color:RGBA(255,0,0,1)
}
  #ileft{
    position: relative;
    width: 101.2%;
    height: auto;
    top: 0px;
    left: -2px;
  }
}

#picHolder{
  position: relative;
  width: 39.3vw;
  height: 23.7vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eaebec;
  background-image: url('../assets/loading.gif');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 10%;
  img{
    left: 0px;
    top: 0px;
    height: 100%;
  }
}

#restPic{
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin: 0.7vw 0px;
  flex-wrap: wrap;
  width: 105%;
}

.restEl{
  width: 9.55vw;
  height: 6vw;
  background-color: #eaebec;
  border: 0.2vw solid #eaebec;
  overflow: hidden;
  margin: 13px 0.4vw 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 21%;
  background-image: url('../assets/loading.gif');
  img{
    cursor: pointer;
    height: 100%;
  }
}

@media only screen and (max-width: 600px) {
#picHolder{
position: relative;
    width: 100vw;
    height: 60.7vw;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eaebec;
  img{
    left: 0px;
    top: 0px;
    height: 100%;
  }
}
  #restPic{
    margin-top: 6px;
  }

  .restEl{
    width: 22vw;
    height: 14vw;
    background-color: #eee;
    border: 3px solid #eee;
    margin: 13px 2vw 0px 0px;
    overflow: hidden;
    img{
      width: 100%;
      cursor: pointer;
    }
  }
}

#iright{
  width: 35%;
  position: absolute;
  right: 0px;
  text-align: left;
  font-size: 1vw;
}

@media only screen and (max-width: 600px) {
  #iright{
    width: 95%;
    position: relative;
    right: 0px;
    text-align: left;
    padding: 10px;
    p{
      width: 100%;
    }
  }
}

#tekst{
  line-height: 1.5;
}

#cijena{
  width: 7.4vw;
  height: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FD0;
  font-size: 1.8vw;
  font-weight: 900;
  margin-top: 4vw;
  border-radius: 1vw 0.2vw 1vw 0.5vw;
  padding-left: 1vw;
  font-size: 1.5vw;
  cursor: pointer;
}

#dodaj{
  opacity: 1;
  position: absolute;
  border-radius: 30px;
  width: 2.1vw;
  height: 2.1vw;
  bottom: 1.5vw;
  left: -0.8vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0, 0, 0, 0.3);
  cursor: pointer;
  font-size: 0.6vw;
  font-weight: 700;
  transition: 0.2s;
  background-color: rgb(212, 0, 0);
  color: #fff;
}

.nds{
  font-size:0.8vw !important
}

@media only screen and (min-width: 601px) {
  #cijena:hover #dodaj{
    background-color: #fff;
    color: #c00;
  }
}

@media only screen and (max-width: 600px) {

.nds{
  font-size:14px !important
}

  #cijena{
    position: absolute;
    width: 118px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FD0;
    font-size: 24px;
    font-weight: 900;
    margin-top: 40px;
    border-radius: 10px 0px 10px 0px;
    top: -32px;
    right: -22px;
  }

  #cijena:active #dodaj{
    background-color: #fff;
    color: #c00;
  }

  #dodaj{
    opacity: 1;
    position: absolute;
    border-radius: 30px;
    width: 40px;
    height: 40px;
    bottom: 1.5vw;
    left: -18px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0, 0, 0, 0.3);
    cursor: pointer;
    font-size: 11px;
    font-weight: 700;
    transition: 0.2s;
    background-color: rgb(212, 0, 0);
    color: #fff;
  }

  #itemHolder{
    position: relative;
    padding: 30px 0px 60px;
  }
}

</style>
